import { SessionStatus } from '@/types/session'
import { Badge } from '@/components/ui/badge'
import { ReactNode } from 'react'

interface HeaderProps {
  sessionCode: string
  status: SessionStatus
  tabs?: ReactNode
  playerInfo?: ReactNode
}

export function Header({ sessionCode, status, tabs, playerInfo }: HeaderProps) {
  const getStatusColor = (status: SessionStatus) => {
    switch (status) {
      case SessionStatus.WAITING:
        return 'bg-[#E2E5EC] text-[#12356B] border-[#CED4DE]'
      case SessionStatus.LIVE:
        return 'bg-[#367A25]/10 text-[#367A25] border-[#367A25]/30'
      case SessionStatus.COMPLETE:
        return 'bg-[#DD6832]/10 text-[#DD6832] border-[#DD6832]/30'
      default:
        return 'bg-[#E2E5EC] text-[#12356B] border-[#CED4DE]'
    }
  }

  return (
    <header className="border-b border-[#CED4DE] bg-white/95 px-4 py-3 backdrop-blur-sm sm:px-6">
      {/* Left side: Logo + Tabs */}
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-4">
          <img
            src="/icons/centauri-logo.png"
            alt="Centauri"
            className="h-10 sm:h-11"
          />
          {tabs && (
            <div className="flex items-center">
              {tabs}
            </div>
          )}
        </div>

        {/* Right side: Session info + Player info */}
        <div className="flex items-center gap-3 sm:gap-5">
          <div className="flex items-center gap-2 text-sm sm:text-base">
            <span className="font-medium text-slate-600">Session:</span>
            <span className="rounded-lg bg-[#E2E5EC] px-3 py-1 font-semibold tracking-[0.12em] text-[#12356B]">
              {sessionCode}
            </span>
          </div>
          <Badge className={`${getStatusColor(status)} ${status === SessionStatus.LIVE ? 'animate-pulse' : ''}`}>
            {status === SessionStatus.LIVE && (
              <span className="mr-1.5 size-2 rounded-full bg-[#367A25]" />
            )}
            {status}
          </Badge>
          {playerInfo && (
            <>
              <div className="h-8 w-px bg-[#CED4DE]" />
              {playerInfo}
            </>
          )}
        </div>
      </div>
    </header>
  )
}
